$(function () {
  if (!customElements.get('home-media-endorsement')) {
    customElements.define(
      'home-media-endorsement',
      class homeMediaEndorsement extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.initSwiper();
        }

        initSwiper() {
          const $this = $(this);
          const $imageContainers = $this.find('.media-logo');
          const $mainSwiper = $this.find('.my-swiper');

          // 如果没有图片或只有一张图片，则不初始化 swiper
          if ($imageContainers.length <= 1) return;

          this.swiper = new Swiper($mainSwiper[0], {
            loop: true,
            autoplay: {
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            },
            navigation: {
              nextEl: $this.find('.swiper-button-next')[0],
              prevEl: $this.find('.swiper-button-prev')[0],
            },
            on: {
              slideChange: (swiper) => {
                // 重置所有图片容器的背景色
                $imageContainers.css('backgroundColor', 'transparent');
                // 设置当前激活slide对应的图片容器背景色
                $imageContainers.eq(swiper.realIndex).css('backgroundColor', 'var(--theme-color-10)');
              },
              init: function () {
                // 初始化时设置第一个图片容器的背景色
                $imageContainers.first().css('backgroundColor', 'var(--theme-color-10)');
              },
            },
          });

          // 添加点击事件
          $imageContainers.on('click', (e) => {
            const index = $(e.currentTarget).index();
            this.swiper.slideToLoop(index);
          });
        }
      }
    );
  }
});
